import { Injectable } from "@angular/core";
import { StaffPriorityLevelsService } from "lib-klab-sdks";
import { map, Observable } from "rxjs";
import { PriorityLevelsPort } from "../../../app/ports/requirement/priority-levels.port";
import { PriorityLevel, PriorityLevelPage, PriorityLevelRequest } from "../../../domain/models/requirement/priority-level.model";
import { mapPriorityLevel, mapPriorityLevelPage, mapPriorityLevelRequest } from "../../mappers/requirement/priority-level.mapper";

@Injectable({ providedIn: "root" })
export class PriorityLevelsPortAdapter implements PriorityLevelsPort {
  constructor(private readonly api: StaffPriorityLevelsService) {}

  list(limit = 100, offset = 0): Observable<PriorityLevelPage> {
    return this.api.list(limit, offset).pipe(
      map(({ data }) => mapPriorityLevelPage(data)),
    );
  }

  get(id: number): Observable<PriorityLevel> {
    return this.api.get(id).pipe(map(({ data }) => mapPriorityLevel(data)));
  }

  create(request: PriorityLevelRequest): Observable<PriorityLevel> {
    return this.api.create(mapPriorityLevelRequest(request)).pipe(map(({ data }) => mapPriorityLevel(data)));
  }

  update(id: number, request: PriorityLevelRequest): Observable<PriorityLevel> {
    return this.api.update(id, mapPriorityLevelRequest(request)).pipe(map(({ data }) => mapPriorityLevel(data)));
  }

  delete(id: number): Observable<void> {
    return this.api.delete(id).pipe(map(() => undefined));
  }
}
